module.exports = __webpack_public_path__ + "img/pin-sharp-dot.c63b4069.svg";